export default "__VITE_ASSET__BuUHPSGu__"